import { useState } from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/App";
import { savingsApi } from "@/lib/savings.api";
import { getApiErrorMessage } from "../../settingsPage.helpers";

export function CreditConversionTool() {
  const { user } = useAuth();
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState<string | null>(null);

  if (!user || user.role !== "super_admin") return null;

  async function handleTrigger() {
    setRunning(true);
    setResult(null);
    try {
      const response = await savingsApi.triggerConversion();
      setResult(
        `${response.data.converted} converti(s), ${response.data.heldForReview} en attente de révision.`,
      );
    } catch (error: unknown) {
      setResult(getApiErrorMessage(error, "Erreur lors du déclenchement."));
    } finally {
      setRunning(false);
    }
  }

  return (
    <section className="border border-danger-border bg-danger-bg">
      <div className="grid gap-3 px-4 py-4 md:grid-cols-[minmax(0,1fr)_auto] md:items-center">
        <div>
          <div className="flex items-center gap-2">
            <AlertTriangle size={16} className="text-danger-text" />
            <h3 className="text-sm font-semibold text-danger-text">
              Conversion manuelle des crédits expirés
            </h3>
          </div>
          <p className="mt-1 text-xs leading-5 text-danger-text">
            Lance immédiatement la conversion des crédits dont la fenêtre de décision est expirée.
            Cette action peut créer de vrais mouvements financiers.
          </p>
          {result && <p className="mt-2 text-xs text-danger-text">{result}</p>}
        </div>
        <Button size="sm" variant="destructive" onClick={handleTrigger} disabled={running}>
          {running ? <Loader2 size={13} className="animate-spin" /> : "Déclencher"}
        </Button>
      </div>
    </section>
  );
}
